import list from 'src/modules/gestorDocumental/list/gestorDocumentalListReducers';
import form from 'src/modules/gestorDocumental/form/gestorDocumentalFormReducers';
import view from 'src/modules/gestorDocumental/view/gestorDocumentalViewReducers';
import destroy from 'src/modules/gestorDocumental/destroy/gestorDocumentalDestroyReducers';
import importerReducer from 'src/modules/gestorDocumental/importer/gestorDocumentalImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
